import { render, staticRenderFns } from "./RelatorioAdministrativo.vue?vue&type=template&id=203a77b2&scoped=true"
import script from "./RelatorioAdministrativo.vue?vue&type=script&lang=js"
export * from "./RelatorioAdministrativo.vue?vue&type=script&lang=js"
import style0 from "./RelatorioAdministrativo.vue?vue&type=style&index=0&id=203a77b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203a77b2",
  null
  
)

export default component.exports